// ===== CSV PARSER =====
// Robust CSV parser that handles:
// - UTF-8 BOM (﻿) at the start of the file
// - Hebrew / Unicode text
// - Commas inside quoted fields
// - Newlines inside quoted fields
// - Escaped double-quotes ("") inside quoted fields
// - CRLF and LF line endings
//
// Returns { headers, rows } where headers is the first row (array of strings)
// and rows is an array of remaining rows (each an array of strings).
export function parseCSV(text) {
  if (!text) return { headers: [], rows: [] };

  // Strip UTF-8 BOM if present
  if (text.charCodeAt(0) === 0xfeff) {
    text = text.slice(1);
  }

  const allRows = [];
  let row = [];
  let field = '';
  let inQuotes = false;
  const n = text.length;
  let i = 0;

  while (i < n) {
    const char = text[i];

    if (inQuotes) {
      if (char === '"') {
        // Escaped quote ("") -> literal quote
        if (text[i + 1] === '"') {
          field += '"';
          i += 2;
          continue;
        }
        inQuotes = false;
        i += 1;
        continue;
      }
      // Normalize CRLF/CR inside quotes to a single LF
      if (char === '\r') {
        field += '\n';
        i += text[i + 1] === '\n' ? 2 : 1;
        continue;
      }
      field += char;
      i += 1;
      continue;
    }

    // Not inside quotes
    if (char === '"') {
      inQuotes = true;
      i += 1;
      continue;
    }
    if (char === ',') {
      row.push(field);
      field = '';
      i += 1;
      continue;
    }
    if (char === '\r') {
      // End of record (handle CRLF)
      row.push(field);
      allRows.push(row);
      row = [];
      field = '';
      i += text[i + 1] === '\n' ? 2 : 1;
      continue;
    }
    if (char === '\n') {
      row.push(field);
      allRows.push(row);
      row = [];
      field = '';
      i += 1;
      continue;
    }
    field += char;
    i += 1;
  }

  // Flush the final field / row
  row.push(field);
  allRows.push(row);

  // Drop a trailing empty row caused by a trailing newline
  while (
    allRows.length > 0 &&
    allRows[allRows.length - 1].length === 1 &&
    allRows[allRows.length - 1][0] === ''
  ) {
    allRows.pop();
  }

  const headers = allRows.length > 0 ? allRows[0] : [];
  const rows = allRows.slice(1);
  return { headers, rows };
}
